module.exports = __webpack_public_path__ + "static/img/硕士_2022_孔玥_ky2022055668@nwafu.edu.cn.2383443.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/硕士_2022_孔玥_ky2022055668@nwafu.edu.cn.jpg
// module id = svh0
// module chunks = 6